<template>
  <div :class="$style.root">
    <div :class="$style.container">
      <Breadcrumbs :links="links"/>
    </div>

    <div :class="$style.imageContainer">
      <v-lazy-image
        v-if="project.current.mainImage"
        :class="$style.img"
        :src="project.current.mainImage"
        :alt="project.current.name"
        :src-placeholder="project.current.mainImage.placeholder"
        :key="`${project.current.name}-head-image`"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { GET_PROJECT } from 'store/getters';
import Breadcrumbs from 'components/Breadcrumbs';

export default {
  name: 'Hero',
  components: { Breadcrumbs },
  computed: {
    ...mapGetters({
      project: GET_PROJECT,
    }),
    links() {
      return [
        {
          name: 'Проекты',
          path: '/projects',
        },
        {
          name: this.project.current.name,
        },
      ];
    },
  },
};
</script>

<style lang="scss" module scoped>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/helpers';

.root {
  min-height: 568px;
  background-size: cover;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;

  @include media('<desktop') {
    min-height: 400px;
  }

  @include media('<tablet') {
    min-height: 300px;
  }

  @include media('<=phone') {
    min-height: 235px;
  }
}

.imageContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.imageContainer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectHero.vue